import ObjectComparer from 'common/services/util/-RFC.ObjectComparer';
import UserNotifications from 'common/notifications/-RFC.userNotifications';

let _users = [];
const observableUsers = new Rx.BehaviorSubject(_users);

/**
 * @ngdoc service
 * @name repositories.UsersRepository
 *
 * @description
 * This class is used to save/add users objects.
 */
const UsersRepository = {

    /**
     * @ngdoc function
     * @name repositories.UsersRepository#add
     * @methodOf repositories.UsersRepository
     * @function
     *
     * @description
     * This function can be used to add a new user to repository.
     *
     * @param {object} user An user object.
     */
    add(user) {

        const indexOfUser = _users.findIndex(_user => String(_user.id) === String(user.id));

        if (indexOfUser === -1) {

            _users.push(user);
            observableUsers.onNext(_users);

        }

    },

    /**
     * @ngdoc function
     * @name repositories.UsersRepository#update
     * @methodOf repositories.UsersRepository
     * @function
     *
     * @description
     * This function can be used to update a user from repository.
     *
     * @param {object} user a user object with new values.
     */
    update(user) {

        const indexOfUser = this.getIndex(user.id);

        if (indexOfUser >= 0) {

            const flattenDiff = ObjectComparer.getFlattenDiff(_users[indexOfUser], user);
            UserNotifications.processUpdate(flattenDiff);

            _users[indexOfUser] = user;
            observableUsers.onNext(_users);

        }

    },

    /**
     * @ngdoc function
     * @name repositories.UsersRepository#replace
     * @methodOf repositories.UsersRepository
     * @function
     *
     * @description
     * This function can be used to replace all stored users with provided data.
     *
     * @param {Array} data An array with new users.
     */
    replace(data) {

        _users = data;
        observableUsers.onNext(_users);

    },

    /**
     * @ngdoc function
     * @name repositories.UsersRepository#getAll
     * @methodOf repositories.UsersRepository
     * @function
     *
     * @description
     * This function can be used to retrieves all users from repository.
     *
     * @returns {Array} users all users from repository
     */
    getAll() {

        return _users;

    },

    /**
     * @ngdoc function
     * @name repositories.UsersRepository#getById
     * @methodOf repositories.UsersRepository
     * @function
     *
     * @description
     * This function can be used to retrieves user from repository by id.
     *
     * @param {integer} userId the id of user.
     *
     * @returns {object} user user with specified id from repository
     */
    getById(userId) {

        let user;
        const indexOfUser = this.getIndex(userId);

        if (indexOfUser >= 0) {

            user = _users[indexOfUser];

        }

        return user;

    },

    /**
    * @ngdoc function
    * @name repositories.UsersRepository#getByEmail
    * @methodOf repositories.UsersRepository
    * @function
    *
    * @description
    * This function can be used to retrieves user from repository by email.
    *
    * @param {string} email email of user.
    *
    * @returns {object} user user with specified email from repository
    */
    getByEmail(email) {

        const user = _users.find(u => u.attributes.email === email);
        return user;

    },

    /**
     * @ngdoc function
     * @name repositories.UsersRepository#getIndex
     * @methodOf repositories.UsersRepository
     * @function
     *
     * @description
     * This function can be used to retrieves index of user from repository by id.
     *
     * @param {integer} userId the id of user.
     *
     * @returns {integer} user index of user from repository
     */
    getIndex(userId) {

        return _users.findIndex(_user => String(_user.id) === String(userId));

    },

    /**
     * @ngdoc function
     * @name repositories.UsersRepository#getObservable
     * @methodOf repositories.UsersRepository
     * @function
     *
     * @description
     * This function can be used to get an observable object for users repository.
     * @returns {Object} an observable object for users repository.
     */
    getObservable() {

        return observableUsers;

    },

};

export default UsersRepository;



// WEBPACK FOOTER //
// ./scripts/common/repositories/-RFC.usersRepository.js